import { getAssistantContextProjection } from "@/lib/api/chat";
import type { AssistantContextProjection } from "@/lib/api/projection-types";
import { createProjectionStore } from "./createProjectionStore";

export const useAssistantContextStore = createProjectionStore<
  AssistantContextProjection,
  []
>(getAssistantContextProjection, []);
